// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__PIv8N","lds-dual-ring":"loader_lds-dual-ring__HFSZZ"};